import React, { forwardRef } from "react";

const GraphicContainer = forwardRef(({ children }, ref) => {
  return (
    <div ref={ref} style={{ margin: "20px auto", width: "100%", maxWidth: "860px", height: 300 }}>
      {children}
    </div>
  );
});

export default GraphicContainer;
